export const roundPerfNow = (): number => ~~performance.now();
